import { render, staticRenderFns } from "./ReInviteForm.vue?vue&type=template&id=bf6c3744&"
import script from "./ReInviteForm.vue?vue&type=script&lang=ts&"
export * from "./ReInviteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports